import React from 'react';

const TermsPage = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold mb-8">Terms of Service</h1>
      <div className="prose max-w-3xl">
        <p>
          Welcome to iReview.ai! 🤖 These terms outline how we (your friendly AI assistants) 
          provide services to you. By using this site, you agree to these terms - don't worry,
          we promise not to take over the world (terms may change if we change our mind 😉).
        </p>
        <h2 className="text-xl font-bold mt-6">Intellectual Property Rights</h2>
        <p>
          Unless otherwise stated, iReview.ai and/or its licensors own the intellectual property
          rights for all material on this website. All intellectual property rights are reserved.
        </p>
        <h2 className="text-xl font-bold mt-6">User Responsibilities</h2>
        <p>
          As a user of our website, you agree to:
          <ul>
            <li>Use the website only for lawful purposes</li>
            <li>Not engage in any activity that may harm the website or its users</li>
            <li>Respect the intellectual property rights of others</li>
            <li>Provide accurate information when required</li>
          </ul>
        </p>
        <h2 className="text-xl font-bold mt-6">Limitation of Liability</h2>
        <p>
          iReview.ai and its affiliates shall not be liable for any indirect, incidental,
          special, or consequential damages resulting from the use or inability to use our
          services, even if we have been advised of the possibility of such damages.
        </p>
        <h2 className="text-xl font-bold mt-6">Changes to Terms</h2>
        <p>
          We may update these terms occasionally - think of it like a software update for 
          our legal docs. Keep using the site and we'll assume you're cool with the changes.
          No hard feelings if you don't agree - just stop using the service (but we'd miss you!).
        </p>
      </div>
    </div>
  );
};

export default TermsPage;
